const FETCHED_ONCE = {};
export default function forever (caches, request, ...requestArgs) {
  let reqKey = request.keyFor(...requestArgs);
  if (reqKey in FETCHED_ONCE) {
    return false;
  } else {
    FETCHED_ONCE[reqKey] = true;
    return true;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/caching/forever.js